// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__7GyJC","footer":"Form_footer__11BXz"};